import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import EditComponent from '../tsx/SelectField';

export default class SelectField extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    constructor(
        glob,
        title: string,
        validators?: any,
        defaultVal: any = null,
        options?: {
            [key: string]: any;
            onChange?: (values, value) => any;
        }
    ) {
        super(glob, title, SelectField.defaultValidators, validators, defaultVal, options);
    }
}
